import { render, staticRenderFns } from "./InsuranceInfo.vue?vue&type=template&id=b082a914&scoped=true&"
import script from "./InsuranceInfo.vue?vue&type=script&lang=ts&"
export * from "./InsuranceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceInfo.vue?vue&type=style&index=0&id=b082a914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b082a914",
  null
  
)

export default component.exports